import detect from "detect-browser";

export default {
  supportsWebRtc: () => {
    const browser = detect.detect();

    //iOS
    if (browser && browser.os === "iOS") {
      if (browser.name === "ios") {
        if (browser.version) {
          if (browser.version.startsWith("10")) return false;
          if (browser.version.startsWith("9")) return false;
          if (browser.version.startsWith("8")) return false;
          if (browser.version.startsWith("7")) return false;
          return true;
        } else {
          return true;
        }
      }
      return false;
    }

    //Android
    if (browser && browser.os.indexOf("Android") !== -1) {
      return true;
    }
    return true;
  },
};






// WEBPACK FOOTER //
// ./src/misc/browser.js